<template>
  <div :style="`transform: rotate(${shape.rotate_angle}deg);`">
    <!--Showing Shapes for square/rectangle-->
    <div
      v-if="shape.type == 'S'"
      :style="{ ...shapesStyles(), position: 'relative' }"
    >
      <rectangle-right-angle v-if="shape.square.show_angles.indexOf('1') !== -1" type="TL" :shape="shape" />
      <rectangle-right-angle v-if="shape.square.show_angles.indexOf('2') !== -1" type="TR" :shape="shape" />
      <rectangle-right-angle v-if="shape.square.show_angles.indexOf('3') !== -1" type="BR" :shape="shape" />
      <rectangle-right-angle v-if="shape.square.show_angles.indexOf('4') !== -1" type="BL" :shape="shape" />
    </div>

    <!--Showing Shapes for circle-->
    <div
      v-if="shape.type == 'C'"
      :style="{ ...shapesStyles(), 'border-radius': '50%' }"
    ></div>

    <!--Showing Shapes for polygon-->
    <canvas
      :id="`polygon_canvas_${canvas_suffix}`"
      :width="shape.shape_styles.width"
      :height="shape.shape_styles.height"
      v-if="shape.type == 'P' && shape.shape_styles"
    ></canvas>
  </div>
</template>
<script>
import RectangleRightAngle from "./RectangleRightAngle.vue";
import { getCSSFromStyles } from "@/components/Common/StyleEditor/utils";
export default {
  data() {
    return {
      canvas_suffix: Date.now() + (Math.random() * 100000).toFixed(),
    };
  },
  props: {
    shape: {
      type: Object,
      required: true,
    },
  },
  components : {
    RectangleRightAngle
  },
  watch: {
    shape: {
      handler: function() {
        // setTimeout is necessary because deafult clearing beahaviour of canvas is happening after watcher excutes so, we want to reverse the order
        setTimeout(() => this.showdata(), 0);
      },
      deep: true,
    },
  },
  methods: {
    shapesStyles() {
      let styles = {};
      styles = getCSSFromStyles(this.shape.shape_styles);
      styles["transform"] = `skewX(${this.shape.square.skew_angle}deg)`;

      return styles;
    },
    drawAngleSymbol(pt3, pt2, pt1, ctx, w) {
      var dx1 = pt1.x - pt2.x;
      var dy1 = pt1.y - pt2.y;
      var dx2 = pt3.x - pt2.x;
      var dy2 = pt3.y - pt2.y;
      var a1 = Math.atan2(dy1, dx1);
      var a2 = Math.atan2(dy2, dx2);
      // draw angleSymbol
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(pt2.x, pt2.y);
      ctx.arc(pt2.x, pt2.y, w, a1, a2);
      ctx.closePath();
      ctx.closePath();
      ctx.strokeStyle = this.shape.shape_styles.border_color;
      ctx.lineWidth = this.shape.shape_styles.border_width;
      ctx.stroke();
    },
    showdata() {
      let canvas = document.getElementById(
        "polygon_canvas_" + this.canvas_suffix
      );
      if (!canvas) return;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(
        0,
        0,
        this.shape.shape_styles.width,
        this.shape.shape_styles.height
      );
      let numberOfSides = this.shape.polygon.sides;

      // Now we want marginX = 10% of width & marginY = 10% of height inside canvas
      const marginX = 0.1 * this.shape.shape_styles.width;
      const marginY = 0.1 * this.shape.shape_styles.height;
      let Xcenter = this.shape.shape_styles.width / 2;
      let Ycenter = this.shape.shape_styles.height / 2;
      let size = Math.min(Xcenter - marginX, Ycenter - marginY);
      let corners = [];
      corners.push({
        x: Xcenter + size * Math.cos(0),
        y: Ycenter + size * Math.sin(0),
      });
      ctx.beginPath();
      ctx.moveTo(Xcenter + size * Math.cos(0), Ycenter + size * Math.sin(0));
      for (let i = 1; i < numberOfSides; i += 1) {
        ctx.lineTo(
          Xcenter + size * Math.cos((i * 2 * Math.PI) / numberOfSides),
          Ycenter + size * Math.sin((i * 2 * Math.PI) / numberOfSides)
        );
        corners.push({
          x: Xcenter + size * Math.cos((i * 2 * Math.PI) / numberOfSides),
          y: Ycenter + size * Math.sin((i * 2 * Math.PI) / numberOfSides),
        });
      }
      ctx.closePath();
      ctx.fillStyle = this.shape.shape_styles.bg_color;
      ctx.fill();
      ctx.strokeStyle = this.shape.shape_styles.border_color;
      ctx.lineWidth = this.shape.shape_styles.border_width;
      ctx.stroke();
      // draw the angle symbols on corners
      let n = corners.length;
      
      let width = this.shape.shape_styles.width / 7;
      if (this.shape.polygon.show_angles && this.shape.polygon.show_angles.length > 0) {
        this.shape.polygon.show_angles.map((each) => {
          if (each - 1 < n - 2) {
            let i = each - 1;
            this.drawAngleSymbol(
              corners[i],
              corners[i + 1],
              corners[i + 2],
              ctx,
              width
            );
          }
          if (each - 1 === n - 2) {
            this.drawAngleSymbol(
              corners[n - 2],
              corners[n - 1],
              corners[0],
              ctx,
              width
            );
          }
          if (each - 1 === n - 1) {
            this.drawAngleSymbol(
              corners[n - 1],
              corners[0],
              corners[1],
              ctx,
              width
            );
          }
        });
      }
    },
  },
  mounted() {
    if (this.shape.type === "P") {
      this.showdata();
    }
  },
};
</script>
